import QRCodeComponent from "qrcode.react";
import { ComponentPropsWithoutRef, ReactNode } from "react";
import styles from "./QrCode.module.scss";
import BaseLinkOrButton from "./BaseLinkOrButton.tsx";
import { FormattedMessage } from "react-intl";
import { clsx } from "clsx";
import MiscellaneousRefresh from "../icons/MiscellaneousRefresh.tsx";

interface QRCodeProps {
  value?: string;
  label: string;
  size?: number;
  imageSettings?: ComponentPropsWithoutRef<
    typeof QRCodeComponent
  >["imageSettings"];
  onRequestRefresh?: () => void;
  isExpired?: boolean;
  imageOverlay?: ReactNode;
}

export default function QrCode({
  value,
  label,
  size = 256,
  imageSettings,
  isExpired,
  onRequestRefresh,
  imageOverlay,
}: QRCodeProps) {
  return (
    <div className={styles.qrCode} style={{ width: size, height: size }}>
      {value && (
        <QRCodeComponent
          size={size}
          value={value}
          level="Q"
          renderAs="canvas"
          role="img"
          aria-label={label}
          imageSettings={imageSettings}
        />
      )}
      {imageOverlay && (
        <div className={styles.imageOverlay}>{imageOverlay}</div>
      )}
      {isExpired && (
        <div className={styles.refreshButtonContainer}>
          <BaseLinkOrButton
            onClick={onRequestRefresh}
            className={clsx(
              "vst-button-pill",
              "vst-button-variant-white",
              styles.refreshButton
            )}
          >
            <MiscellaneousRefresh />
            <FormattedMessage defaultMessage="Refresh" />
          </BaseLinkOrButton>
        </div>
      )}
    </div>
  );
}
